import { BvIcon } from "bevi-icon";
import { ReactComponent as BarcodeIcon } from "../assets/icons/barcode.svg";

function RenderMethodIcon(methodName: string, size: number = 20) {
  const name = methodName?.toLowerCase();
  const style = { marginTop: "-2px" };

  if (name === "cartão de crédito")
    return <><BvIcon name="creditCard" variant="duo" weight={600} width={size} height={size} style={style} /> Crédito</>;
  if (name === "cartão de débito")
    return <><BvIcon name="creditCard" variant="solid" weight={600} width={size} height={size} style={style} /> Débito</>;
  if (name === "pix")
    return <><BvIcon name="pix" variant="duo" weight={600} width={size} height={size} style={style} /> Pix</>;
  if (name === "boleto")
    return <><BarcodeIcon width={size} height={size} style={style} /> Boleto</>;

  return methodName || "-";
}

export default RenderMethodIcon;
